import { store } from '../../store-config';

export const getInternationalizationInfo = () => {
  return store.getState().auth.appState.internationalizationInfo;
}